import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 14:42:21
 * @LastEditTime: 2021-06-11 16:50:30
 * @LastEditors: wangshengqiang
 * @Description:
 */
import classnames from 'classnames';
import React from 'react'; // import Fixed from '../../components/_common/FixedBottom/Fixed';

import { dispatch } from '@/store';
import BaseModule, { ModuleContext } from '../BaseModule';
const InitialPremiumModule = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    id,
    moduleUid,
    children,
    Render
  } = props;
  if (!children || children.length === 0) return null;

  if (!moduleUid) {
    return /*#__PURE__*/React.createElement("div", {
      id: id
    }, /*#__PURE__*/React.createElement(Render, {
      components: children
    }));
  }

  return /*#__PURE__*/React.createElement(ModuleContext.Provider, {
    value: _objectSpread(_objectSpread({}, props), {}, {
      buttonCode: id
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "components-toolbar-render"
  }, /*#__PURE__*/React.createElement("div", {
    className: "toolbar-module-inner"
  }, /*#__PURE__*/React.createElement(Render, {
    components: children
  }))));
});
export default InitialPremiumModule;